import './tableHeader.css'
import { InputText } from "primereact/inputtext";
import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { MouseEvent } from "react";
import { useAppDispatch } from '../../redux/hooks';
import { openInstantQuotationModal } from '../../features/instantQuotationSlice';

export interface TableHeaderProps {
    setGlobalFilterValue: Dispatch<SetStateAction<string>>;
    onGlobalFilterChange: (e: any) => void;
    globalFilterValue: string;
    resetTable: () => void;
}
export default function TableHeader(props: TableHeaderProps)
{
    const { t } = useTranslation("locale");

    const onClick = (_event: MouseEvent<HTMLButtonElement>) => {
        props.resetTable();
    };

    const dispatch = useAppDispatch();

    return <div className="header-container mb-4">
        <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText 
                value={props.globalFilterValue} 
                onChange={props.onGlobalFilterChange}
                className="w-full max-w-19rem"
                placeholder={t("keywordSearch")}
                data-cy={"keyword-search"} 
            />
        </span>
        <Button
            label={t("resetTable")}
            data-cy={"reset-table-button"}
            className="p-button p-button-outlined p-button-secondary secondary-outlined-button ml-3"
            onClick={onClick}
        />
        <div className='button-container'>
            <Button
                icon="pi pi-plus"
                label={t("instantQuotation.instantQuotation")}
                data-cy={"open-instant-quotation"}
                className="p-button"
                onClick={() => dispatch(openInstantQuotationModal())}
            />
        </div>
    </div>
}
